import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridsterModule } from 'angular2gridster';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';

@NgModule({
  imports: [
    CommonModule,
    GridsterModule.forRoot()
  ],
  declarations: [DashboardComponent, ErrorPageComponent]
})
export class HomeModule { }
